import React from 'react';
import { SearchIcon, CalendarIcon } from 'lucide-react';
interface CoffeeFiltersProps {
  activeFilter: 'all' | 'upcoming' | 'mine' | 'past';
  setActiveFilter: (filter: 'all' | 'upcoming' | 'mine' | 'past') => void;
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  selectedTopic: string;
  setSelectedTopic: (topic: string) => void;
}
const CoffeeFilters: React.FC<CoffeeFiltersProps> = ({
  activeFilter,
  setActiveFilter,
  searchQuery,
  setSearchQuery,
  selectedTopic,
  setSelectedTopic
}) => {
  const eventTypes = [{
    id: 'all',
    name: 'Tutti gli eventi'
  }, {
    id: 'online',
    name: 'Online'
  }, {
    id: 'in-person',
    name: 'Dal vivo'
  }];
  return <div className="bg-white rounded-xl border border-gray-200 p-4" data-id="element-320">
      <div className="flex flex-col md:flex-row md:items-center space-y-4 md:space-y-0 md:space-x-4" data-id="element-321">
        {/* Search input */}
        <div className="relative flex-1" data-id="element-322">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-323">
            <SearchIcon size={18} className="text-gray-400" data-id="element-324" />
          </div>
          <input type="text" placeholder="Cerca per titolo o host..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:ring-custom-green focus:border-custom-green sm:text-sm" data-id="element-325" />
        </div>
        {/* Event Type selector */}
        <div className="w-full md:w-64" data-id="element-326">
          <select value={selectedTopic} onChange={e => setSelectedTopic(e.target.value)} className="block w-full pl-3 pr-10 py-2 border border-gray-300 rounded-md leading-5 bg-white focus:outline-none focus:ring-custom-green focus:border-custom-green sm:text-sm" data-id="element-327">
            {eventTypes.map(type => <option key={type.id} value={type.id} data-id="element-328">
                {type.name}
              </option>)}
          </select>
        </div>
      </div>
      {/* Filter tabs */}
      <div className="mt-4 border-t border-gray-200 pt-4" data-id="element-329">
        <div className="flex space-x-4 overflow-x-auto" data-id="element-330">
          <button onClick={() => setActiveFilter('all')} className={`px-3 py-2 text-sm font-medium rounded-md whitespace-nowrap ${activeFilter === 'all' ? 'bg-custom-green text-white' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-331">
            Tutto
          </button>
          <button onClick={() => setActiveFilter('upcoming')} className={`px-3 py-2 text-sm font-medium rounded-md whitespace-nowrap ${activeFilter === 'upcoming' ? 'bg-custom-green text-white' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-332">
            Prossimi eventi
          </button>
          <button onClick={() => setActiveFilter('mine')} className={`px-3 py-2 text-sm font-medium rounded-md whitespace-nowrap ${activeFilter === 'mine' ? 'bg-custom-green text-white' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-333">
            I miei eventi
          </button>
          <button onClick={() => setActiveFilter('past')} className={`px-3 py-2 text-sm font-medium rounded-md whitespace-nowrap ${activeFilter === 'past' ? 'bg-custom-green text-white' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-334">
            Eventi passati
          </button>
        </div>
      </div>
    </div>;
};
export default CoffeeFilters;